<template>
  <div class="doc-menu">
    <dl>
      <template v-for="item in menuList">
        <dt v-if="item.path != '/' && item.path != '*'" :key="item.name">
          <div>
            <sup>{{ item.title }}</sup>
            <span>{{ item.meta.title }}</span>
          </div>
        </dt>

        <template v-for="subItem in item.children">
          <dd :key="subItem.name">
            <router-link :to="{ name: subItem.name }"
              >{{ subItem.title }}
              <span>{{ subItem.meta.title }}</span>
            </router-link>
          </dd>
        </template>
      </template>
    </dl>
  </div>
</template>
<script>
import routerss from "../../../router.js";

export default {
  data() {
    return {
      menuList: []
    };
  },
  mounted() {
    this.menuList = routerss.options.routes;
  }
};
</script>

<style lang="less" scoped>
.doc-menu {
  background-color: #f7f7f7;
  z-index: 1;
  overflow-y: scroll;
  width: 256px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 140px 40px 0 17px;
  box-shadow: inset 16px 0 0 0px #fff, inset 17px 0 0 0px #eaeaea;
  dl {
    dt {
      font-size: 16px;

      box-shadow: -17px 0px #cecece;

      padding: 10px 0 0 16px;
      div {
        border-bottom: 1px solid #e2e2e2;
        height: 40px;
        line-height: 40px;
        sup {
          font-size: 10px;
          top: -1.2em;
          width: 36px;
          display: inline-block;
          color: #bfbfbf;
          text-transform: lowercase;
        }
        span {
          font-weight: 500;
        }
      }
    }

    dd {
      box-shadow: -17px 0px #e4e4e4;
      margin: 0;
      padding: 10px 0 0 16px;
      a {
        display: block;
        font-size: 13px;
        text-decoration: none;
        height: 30px;
        line-height: 30px;
        text-indent: 36px;
        color: #666;
        span {
          color: #999;
          margin-left: 0.5em;
        }
        &:not(.router-link-exact-active):hover {
          color: #333;
          span {
            color: #333;
          }
        }
      }
      a.router-link-exact-active {
        background-color: #eaeaea;
        border-radius: 30px;
      }
    }
  }
}
</style>
